module.exports = __webpack_public_path__ + "img/BrilleFielmannIchMeinEdith.7953a979.svg";